import * as ActionTypes from './types.action';

export const setPrevRoute = (route, params) => ({
  type: ActionTypes.SET_PREV_ROUTE_SUCCESS,
  route,
  params,
});
